import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { StytchProvider } from "@stytch/react";
import { StytchHeadlessClient } from "@stytch/vanilla-js/headless";
import { HelmetProvider } from 'react-helmet-async';
import "./global.css";

// import * as Sentry from "@sentry/react";

const stytch = new StytchHeadlessClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <StytchProvider stytch={stytch}>
        <App />
      </StytchProvider>
    </HelmetProvider>
  </React.StrictMode>
);
